import { render, staticRenderFns } from "./LayoutsMoodColorsSection.vue?vue&type=template&id=720d3937"
import script from "./LayoutsMoodColorsSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsMoodColorsSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsMoodColorsSection.vue?vue&type=style&index=0&id=720d3937&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports